import React from 'react';
import { ButtonLink } from '../ui/ButtonLink';
import type { LinkItem } from '../../types/content';
interface ClosingInvitationProps {
  title: string;
  body: string;
  primary: LinkItem;
  secondary?: LinkItem;
}
export function ClosingInvitation({
  title,
  body,
  primary,
  secondary
}: ClosingInvitationProps) {
  return <section className="px-5 pb-24 md:px-8 md:pb-32" data-id="element-447" data-mp="hm6t3pznxoxo">
      <div className="bg-dots mx-auto max-w-7xl rounded-[32px] border border-white bg-white/50 px-6 py-20 text-center shadow-glass md:py-24" data-id="element-448" data-mp="15b9khpk3mw5d">
        <h2 className="text-balance text-3xl font-semibold tracking-display sm:text-4xl md:text-5xl" data-id="element-449" data-mp="1a8rl8snyq52a">{title}</h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-450" data-mp="vkwpf3enrkkz">{body}</p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-451" data-mp="10iou6y0ej16l">
          <ButtonLink to={primary.to} href={primary.href} icon={primary.href ? 'external' : null} data-id="element-452" data-mp="1o92cvxx3jnoi">
            {primary.label}
          </ButtonLink>
          {secondary ? <ButtonLink to={secondary.to} href={secondary.href} variant="secondary" icon={secondary.href ? 'external' : null} data-id="element-453" data-mp="2furdyhce4uzb">
              {secondary.label}
            </ButtonLink> : null}
        </div>
      </div>
    </section>;
}